import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DistributorsTicketsCountService } from 'src/app/services/distributorsTicketsCount/distributorsTicketsCount.service';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';
import { SMSMessagingService } from 'src/app/services/messaging/SMSmessaging.service';
import { SMTPMessagingService } from 'src/app/services/messaging/SMTPmessaging.service';
import { AuthenticateResponseModel } from '../../../../models/authorize/authenticate-model';

@Component({
    selector: 'app-distributorsTicketsCount-card',                  // This is how the component is placed in the HTML
    templateUrl: './distributorsTicketsCount-card.component.html',  // This is the template file
    styleUrls: ['./distributorsTicketsCount-card.component.scss'],  // This the scss styling (could be css)
})
export class DistributorsTicketsCountCardComponent implements OnInit {

    distributorsTicketsCount$ = new BehaviorSubject<string | undefined>(undefined);
    distributorName$ = new BehaviorSubject<string | undefined>(undefined);
    SMSmessageResult$ = new BehaviorSubject<string | undefined>(undefined);
    SMTPmessageResult$ = new BehaviorSubject<string | undefined>(undefined);

    isAdmin = false;

    constructor(
        private _authorizeService: AuthorizeService,
        private _distributorsTicketsCountService: DistributorsTicketsCountService,
        private _SMSMessagingService: SMSMessagingService,
        private _SMTPMessagingService: SMTPMessagingService
    ) {

    }

    ngOnInit() {
        this._distributorsTicketsCountService.getDistributorsTicketsCount$().subscribe(result => {
            this.distributorsTicketsCount$.next(result.scalar);
        });

        this._authorizeService.user$.subscribe(user => {
            this.distributorName$.next(user?.distributorName);
            this.isAdmin = this._authorizeService.checkAuthorization("27", user?.rights);
        });

        //this._SMSMessagingService.sendSMSMessage$("+15733302974", encodeURIComponent("Test message 12/28/2023")).subscribe(result => {
        //    this.SMSmessageResult$.next(result.scalar);
        //});

        //let date_String = new Date().toISOString();
        //let messageString = "Email Debug Message Sent at " + date_String;

        //this._SMTPMessagingService.sendSMTPMessage$("dweiss@unidev.com", "Test Message From One-Tank", encodeURIComponent(messageString)).subscribe(result => {
        //    this.SMTPmessageResult$.next(result.scalar);
        //});
    }

}
